import { createBrowserRouter } from "react-router"
import { createRootRoute, routes } from "src/router/routes"

export default function createAppRouter() {
  return createBrowserRouter([createRootRoute(routes)], {})
}
